import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import { Button } from '../../Button/index.js';
import { Modal } from 'react-bootstrap';
import { ModalHeader } from '../../ModalHeader.js';
import { i18n } from '../../../i18n/translate.js';
import { onExecuteKeyDown } from '../../../utils/KeyboardUtil.js';
import { FAIcon } from '../../fa-icon/component.js';
var LanguageModalBody = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var buttonDisabled = _ref.buttonDisabled,
    confirmSelection = _ref.confirmSelection,
    enforceSelection = _ref.enforceSelection,
    languages = _ref.languages,
    onClose = _ref.onClose,
    renderedTitle = _ref.renderedTitle,
    selected = _ref.selected,
    setSelected = _ref.setSelected,
    showLanguageModal = _ref.showLanguageModal;
  return /*#__PURE__*/React.createElement(Modal, {
    animation: false
    /* @ts-ignore */,
    container: ref,
    "aria-labelledby": "language-modal-title",
    className: "languages-modal",
    dialogClassName: "foundry",
    id: "languages-modal",
    show: showLanguageModal
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    canClickOff: !enforceSelection,
    closeButton: true,
    onCancel: onClose,
    title: renderedTitle,
    titleId: "language-modal-title"
  }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "language-picker-area",
    role: "menu",
    "aria-label": i18n.t('select a language'),
    tabIndex: 0
  }, Object.entries(languages).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      code = _ref3[0],
      native_name = _ref3[1].native_name;
    var isSelected = selected === code;
    return /*#__PURE__*/React.createElement("div", {
      "aria-pressed": isSelected,
      className: "language-option ".concat(isSelected ? 'is-selected' : ''),
      key: code,
      lang: code,
      onClick: function onClick() {
        return setSelected(code);
      },
      onKeyDown: onExecuteKeyDown(function () {
        return setSelected(code);
      }),
      role: "button",
      tabIndex: -1,
      "data-object-type": "languages",
      "data-object-id": code,
      "data-selected": isSelected
    }, native_name, isSelected && /*#__PURE__*/React.createElement(FAIcon, {
      listItem: true,
      icon: "check",
      color: "teal"
    }));
  }))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    renderAsLegacy: true,
    id: "language-modal-cancel-button",
    onClick: onClose,
    style: "secondary",
    branded: true
  }, i18n.t('Cancel')), /*#__PURE__*/React.createElement(Button, {
    renderAsLegacy: true,
    disabled: buttonDisabled,
    id: "language-modal-save-button",
    onClick: confirmSelection,
    style: "primary",
    branded: true
  }, i18n.t('Save'))));
});
LanguageModalBody.displayName = 'LanguageModalBody';
export { LanguageModalBody };